<template>
  <div class="content ok" v-on:click="sectionClicked">
    <perfect-scrollbar class="configMenu">
      <li :class="{active: menuActive === 'general'}"
        v-on:click="selectMenu('general')">
        General Configurations
        <p>Site name and other info</p></li>
      <li :class="{active: menuActive === 'footer'}"
        v-on:click="selectMenu('footer')">
        Footer Configurations
        <p>Address, contacts and links</p></li>
      <li :class="{active: menuActive === 'email'}"
        v-on:click="selectMenu('email')">
        Email Settings
        <p>Email provider and sender</p></li>
      <li :class="{active: menuActive === 'maintenance'}"
        v-on:click="selectMenu('maintenance')">
        Under Maintenance
      <p>Under maintenance page config</p></li>
      <li :class="{active: menuActive === 'dialog'}"
        v-on:click="selectMenu('dialog')">
        Dialog
        <p>Display dialog on front-end</p></li>
      <li :class="{active: menuActive === 'account'}"
        v-on:click="selectMenu('account')">
        Account
        <p>Two Factor Authentication for account</p></li>
    </perfect-scrollbar>
    <div class="ccTitle" v-if="menuActive === 'footer'">Footer Configurations</div>
    <div class="ccTitle" v-else-if="menuActive === 'general'">General Configurations</div>
    <div class="ccTitle" v-else-if="menuActive === 'email'">Email Settings</div>
    <div class="ccTitle" v-else-if="menuActive === 'maintenance'">Maintenance Page</div>
    <div class="ccTitle" v-else-if="menuActive === 'dialog'">Dialog Settings</div>
    <div class="ccTitle" v-else-if="menuActive === 'account'">Admin Account</div>
    <div class="configContent loading" v-if="loading"></div>
    <perfect-scrollbar class="configContent" v-else-if="menuActive === 'general'">
      <div class="sectionItem">
        <h2>Site Identity</h2>
        <div class="configItem canEdit" v-on:click="editText('siteName', cf.siteName,
          'Site Name', 'text', true)">
          <h4>Site Name</h4>
          <p>{{cf.siteName[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('siteDescriptions',
          cf.siteDescriptions, 'Site Description', 'textarea', true)">
          <h4>Site Description</h4>
          <p>{{cf.siteDescriptions[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('siteUrl', cf.siteUrl,
          'Site Url', 'text')">
          <h4>Site Url</h4>
          <p>{{cf.siteUrl}}</p>
        </div>
        <div class="configItem">
          <h4>Logo</h4>
          <div class="galleryCnt">
            <div class="galleryItem invLogo" :class="cf.logo[lang].mimetype.split('/')[1]"
              v-if="cf.logo && cf.logo[lang]"
              :style="{'background-image': `url(${cf.logo[lang].imageSm})`}"
              v-on:click="editText('logo', cf.logo, 'Logo', 'media/image', true, true)">
            </div>
            <div class="galleryItem invLogo add" v-else
              v-on:click="editText('logo', cf.logo, 'Logo', 'media/image', true, true)">
              Add Logo</div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Date &amp; Time</h2>
        <div class="configItem canEdit" v-on:click="editText('timezone', cf.timezone,
          'Timezone', 'select')" v-if="1>2">
          <h4>Timezone</h4>
          <p>{{cf.timezone}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('dateFormat', cf.dateFormat,
          'Date Format', 'text')">
          <h4>Date Format</h4>
          <p>{{cf.dateFormat}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('timeFormat', cf.timeFormat,
          'Time Format', 'text')">
          <h4>Time Format</h4>
          <p>{{cf.timeFormat}}</p>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Article Interactions</h2>
        <div class="configItem configToggle">
          <h4>Article Comment</h4>
          <div class="toggle"  v-on:click="enableComment">
            <div class="radioItem" :class="{on: cf.enableArticleComment === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Enable comment feature on article
            </div>
          </div>
        </div>
      </div>
    </perfect-scrollbar>
    <perfect-scrollbar class="configContent" v-else-if="menuActive === 'footer'">
      <div class="sectionItem">
        <h2>About</h2>
        <div class="configItem">
          <h4>Footer Logo</h4>
          <div class="galleryCnt">
            <div class="galleryItem invLogo" :class="cf.footerLogo[lang].mimetype.split('/')[1]"
              v-if="cf.footerLogo && cf.footerLogo[lang]"
              :style="{'background-image': `url(${cf.footerLogo[lang].imageSm})`}"
              v-on:click="editText('footerLogo', cf.footerLogo,
              'footerLogo', 'media/image', true, true)">
            </div>
            <div class="galleryItem invLogo add" v-else
              v-on:click="editText('footerLogo', cf.footerLogo,
              'footerLogo', 'media/image', true, true)">
              Add Logo</div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('footerAddressLabel',
          cf.footerAddressLabel, 'About Label', 'text', true)">
          <h4>About Label</h4>
          <p>{{cf.footerAddressLabel[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('footerAddress',
          cf.footerAddress, 'About Descriptions', 'textarea', true)">
          <h4>About Descriptions</h4>
          <p>{{cf.footerAddress[lang]}}</p>
        </div>
        <div class="configItem">
          <h4>Phone</h4>
          <div class="numberCnt">
            <div class="numberItem support phone" v-for="(item, i) in cf.phone"
              :key="`phone${i}`" v-on:click="editItem('phone', 'Phone Number', i, item)">
              <h4>{{item.value}}</h4>
              <div class="delete" v-on:click.stop="deleteItem('phone',
                'Phone Number', i, item)"></div>
            </div>
            <div class="numberItem support phone add"
              v-on:click="addItem('phone', 'Phone Number')">
              Add Phone Number
            </div>
          </div>
        </div>
        <div class="configItem">
          <h4>Email</h4>
          <div class="numberCnt">
            <div class="numberItem support phone" v-for="(item, i) in cf.email"
              :key="`email${i}`" v-on:click="editItem('email', 'Email Address', i, item)">
              <h4>{{item.value}}</h4>
              <div class="delete" v-on:click.stop="deleteItem('email',
                'Email Address', i, item)"></div>
            </div>
            <div class="numberItem support phone add"
              v-on:click="addItem('email', 'Email Address')">
              Add Email Address
            </div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Social Media</h2>
        <div class="configItem canEdit" v-on:click="editText('footerSocmedLabel',
          cf.footerSocmedLabel, 'Social Media Label', 'text', true)">
          <h4>Social Media Label</h4>
          <p>{{cf.footerSocmedLabel[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('footerSocmedDesc',
          cf.footerSocmedDesc, 'Social Media Descriptions', 'textarea', true)">
          <h4>Social Media Descriptions</h4>
          <p>{{cf.footerSocmedDesc[lang]}}</p>
        </div>
        <div class="configItem">
          <h4>Social Media</h4>
          <div class="galleryCnt">
            <div class="galleryItem product" v-for="(item, i) in cf.socmed"
              :key="`product${i}`" v-on:click="editSocmed(i, item)">
              <div class="thumb" :class="item.media.mimetype.split('/')[1]"
                v-if="item.media" :style="{'background-image': `url(${item.media.imageSm})`}">
              </div>
              <div class="thumb noImg" v-else></div>
              <h4>{{item.name}}</h4>
              <p v-if="item.url">{{item.url}}</p>
              <div class="delete" v-on:click.stop="deleteSocmed(i, item)"></div>
            </div>
            <div class="galleryItem product add" v-on:click="addSocmed">Add Social Media</div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Logos</h2>
        <div class="configItem canEdit" v-on:click="editText('footerLogosLabel',
          cf.footerLogosLabel, 'Logo Label', 'text', true)">
          <h4>Logo Label</h4>
          <p>{{cf.footerLogosLabel[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('footerLogosDesc',
          cf.footerLogosDesc, 'Logo Descriptions', 'textarea', true)">
          <h4>Logo Descriptions</h4>
          <p>{{cf.footerLogosDesc[lang]}}</p>
        </div>
        <div class="configItem">
          <h4>Logo</h4>
          <div class="galleryCnt">
            <div class="galleryItem product" v-for="(item, i) in cf.footerLogos"
              :key="`product${i}`" v-on:click="editFooterLogo(i, item)">
              <div class="thumb" :class="item.media.mimetype.split('/')[1]"
                v-if="item.media" :style="{'background-image': `url(${item.media.imageSm})`}">
              </div>
              <div class="thumb noImg" v-else></div>
              <h4>{{item.name}}</h4>
              <p v-if="item.url">{{item.url}}</p>
              <div class="delete" v-on:click.stop="deleteFooterLogo(i, item)"></div>
            </div>
            <div class="galleryItem product add" v-on:click="addFooterLogo">Add Logo</div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Links</h2>
        <div v-for="(item, i) in cf.page" :key="`pg${i}`">
          <div class="configItem canEdit" v-on:click="editTextPage(item, 'title',
            item.title, 'Link Name', 'text', true)">
            <h4>Link Name</h4>
            <p>{{item.title[lang]}}</p>
          </div>
          <div class="configItem">
            <h4>Link Item</h4>
            <div class="galleryCnt">
              <div class="galleryItem product noImg" v-for="(link, i2) in item.links"
                :key="`link${i2}`" v-on:click="editPageItem(item, i2, link)">
                <h4>{{link.name[lang]}}</h4>
                <p v-if="link.url">{{link.url[lang]}}</p>
                <div class="delete" v-on:click.stop="deletePageItem(item, i2, link)"></div>
              </div>
              <div class="galleryItem product noImg add"
                v-on:click="addPageItem(item)">Add Item</div>
            </div>
          </div>
          <div class="deleteLink" v-on:click="deletePage(i, item)">Delete link group</div>
        </div>
        <div class="addSection btnAdd" v-on:click="addPage">Add link group</div>
      </div>
      <div class="sectionItem">
        <h2>Contact</h2>
        <div class="configItem configToggle">
          <h4>Contact Button</h4>
          <div class="toggle" v-on:click="toggle('enableSupport')">
            <div class="radioItem" :class="{on: cf.enableSupport === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display contact button on bottom right page
            </div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('supportLabel',
          cf.supportLabel, 'Contact Label', 'text', true)">
          <h4>Contact Label</h4>
          <p>{{cf.supportLabel[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('supportInfo',
          cf.supportInfo, 'Contact Information', 'text', true)">
          <h4>Contact Information</h4>
          <p>{{cf.supportInfo[lang]}}</p>
        </div>
        <div class="configItem">
          <h4>Contact Item</h4>
          <div class="galleryCnt">
            <div class="galleryItem product contact" v-for="(item, i) in cf.support"
              :key="`support${i}`" v-on:click="editSupport(i, item)">
              <div class="thumb" :class="[item.type, {wa: item.isWhatsApp}]"></div>
              <h4>{{item.name}}</h4>
              <p v-if="item.type === 'Phone' && item.phone">{{item.phone}}</p>
              <p v-if="item.type === 'Email' && item.email">{{item.email}}</p>
              <p v-if="item.type === 'Help Page' && item.url">{{item.url}}</p>
              <div class="delete" v-on:click.stop="deleteSupport(i, item)"></div>
            </div>
            <div class="galleryItem product contact add" v-on:click="addSupport">
              Add Item
            </div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Subscription</h2>
        <div class="configItem configToggle">
          <h4>Subscription form</h4>
          <div class="toggle" v-on:click="toggle('enableSubscription')">
            <div class="radioItem" :class="{on: cf.enableSubscription === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display subscription form on footer
            </div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('subscriptionLabel',
          cf.subscriptionLabel, 'Subscription Label', 'text', true)">
          <h4>Subscription Label</h4>
          <p>{{cf.subscriptionLabel[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('subscriptionInfo',
          cf.subscriptionInfo, 'Subscription Information', 'text', true)">
          <h4>Subscription Information</h4>
          <p>{{cf.subscriptionInfo[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('subscriptionButton',
          cf.subscriptionButton, 'Button Label', 'text', true)">
          <h4>Button Label</h4>
          <p>{{cf.subscriptionButton[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="setColor('subscriptionBgColor')">
          <h4>Dialog Background Color</h4>
          <p :class="{hasColor: cf.subscriptionBgColor}"><span class="color"
            v-if="cf.subscriptionBgColor" :style="{'background-color': cf.subscriptionBgColor}"
            ></span>{{cf.subscriptionBgColor}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="setColor('subscriptionTextColor')">
          <h4>Dialog Text Color</h4>
          <p :class="{hasColor: cf.subscriptionTextColor}"><span class="color"
            v-if="cf.subscriptionTextColor" :style="{'background-color': cf.subscriptionTextColor}"
            ></span>{{cf.subscriptionTextColor}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('subscriptionThankYouTitle',
          cf.subscriptionThankYouTitle, 'Success Title', 'text', true)">
          <h4>Success Title</h4>
          <p>{{cf.subscriptionThankYouTitle[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('subscriptionThankYouDesc',
          cf.subscriptionThankYouDesc, 'Success Subtitle', 'text', true)">
          <h4>Success Subtitle</h4>
          <p>{{cf.subscriptionThankYouDesc[lang]}}</p>
        </div>
        <div class="configItem">
          <h4>Form Item</h4>
          <div class="galleryCnt">
            <div class="galleryItem product contact" v-for="(item, i) in cf.subFormField"
              :key="`support${i}`" v-on:click="editSubscriptionForm(i, item)">
              <div class="thumb formField" :class="[item.type, {wa: item.isWhatsApp}]"></div>
              <h4 v-if="item.label && item.label[lang]">{{item.label[lang]}}</h4>
              <h4 v-else class="noTitle">No Label</h4>
              <p v-if="item.placeholder && item.placeholder[lang]">
                {{item.placeholder[lang]}}</p>
              <div class="delete" v-on:click.stop="deleteSubscriptionForm(i, item)"></div>
            </div>
            <div class="galleryItem product contact add" v-on:click="addSubscriptionForm">
              Add Item
            </div>
          </div>
        </div>
        <div class="configItem configToggle">
          <h4>Enable Email Verification</h4>
          <div class="toggle" v-on:click="toggle('subscriptionEmailVerification')">
            <div class="radioItem" :class="{on: cf.subscriptionEmailVerification === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Verify email for new subscriber
            </div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Copyright</h2>
        <div class="configItem canEdit" v-on:click="editText('copyright',
          cf.copyright, 'Copyright Label', 'text', true)">
          <h4>Copyright Label</h4>
          <p>{{cf.copyright[lang]}}</p>
        </div>
      </div>
    </perfect-scrollbar>
    <perfect-scrollbar class="configContent" v-else-if="menuActive === 'email'">
      <div class="sectionItem">
        <h2>Provider</h2>
        <div class="configItem canEdit" v-on:click="editText('emailProvider',
          cf.emailProvider, 'Email Provider', 'select')">
          <h4>Email Provider</h4>
          <p>{{cf.emailProvider}}</p>
        </div>
        <template v-if="cf.emailProvider === 'Mailgun'">
          <div class="configItem canEdit" v-on:click="editText('mailgunApiKey',
            cf.mailgunApiKey, 'Mailgun API Key', 'text')">
            <h4>Mailgun API Key</h4>
            <p>{{cf.mailgunApiKey}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('mailgunDomain',
            cf.mailgunDomain, 'Mailgun Domain', 'text')">
            <h4>Mailgun Domain</h4>
            <p>{{cf.mailgunDomain}}</p>
          </div>
        </template>
        <template v-else-if="cf.emailProvider === 'SMTP'">
          <div class="configItem canEdit" v-on:click="editText('smtpHost',
            cf.smtpHost, 'SMTP Host', 'text')">
            <h4>SMTP Host</h4>
            <p>{{cf.smtpHost}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('smtpPort',
            cf.smtpPort, 'SMTP Port', 'text')">
            <h4>SMTP Port</h4>
            <p>{{cf.smtpPort}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('smtpSecretKey',
            cf.smtpSecretKey, 'SMTP Secret Key', 'text')" v-if="1>2">
            <h4>SMTP Secret Key</h4>
            <p>{{cf.smtpSecretKey}}</p>
            <div class="fieldHint">You can leave SMTP Secret Key if you fill SMTP Passowrd</div>
          </div>
        </template>
      </div>
      <div class="sectionItem">
        <h2>Email Sender</h2>
        <div class="configItem canEdit" v-on:click="editText('emailSenderName',
          cf.emailSenderName, 'Email Sender Name', 'text')">
          <h4>Email Sender Name</h4>
          <p>{{cf.emailSenderName}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('emailSender',
          cf.emailSender, 'Email Sender', 'text')">
          <h4>Email Sender</h4>
          <p>{{cf.emailSender}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('smtpPassword',
          cf.smtpPassword, 'SMTP Email Password', 'text')"
          v-if="cf.emailProvider === 'SMTP'">
          <h4>SMTP Email Password</h4>
          <p>{{cf.smtpPassword}}</p>
          <div class="fieldHint" v-if="1>2">
            You can leave this password empty if you fill SMTP Secret Key</div>
        </div>
      </div>
    </perfect-scrollbar>
    <perfect-scrollbar class="configContent" v-else-if="menuActive === 'maintenance'">
      <div class="sectionItem">
        <h2>Maintenance Config</h2>
        <div class="configItem configToggle">
          <h4>Under Maintenance</h4>
          <div class="toggle" v-on:click="toggle('underMaintenance')">
            <div class="radioItem" :class="{on: cf.underMaintenance === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display under maintenance page
            </div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="setColor('maintenanceBgColor')">
          <h4>Background Color</h4>
          <p :class="{hasColor: cf.maintenanceBgColor}"><span class="color"
            v-if="cf.maintenanceBgColor" :style="{'background-color': cf.maintenanceBgColor}"
            ></span>{{cf.maintenanceBgColor}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="setColor('maintenanceTextColor')">
          <h4>Text Color</h4>
          <p :class="{hasColor: cf.maintenanceTextColor}"><span class="color"
            v-if="cf.maintenanceTextColor" :style="{'background-color': cf.maintenanceTextColor}"
            ></span>{{cf.maintenanceTextColor}}</p>
        </div>
        <div class="configItem">
          <h4>Background Image</h4>
          <div class="galleryCnt">
            <div class="galleryItem invLogo"
              :class="cf.maintenanceBg[lang].mimetype.split('/')[1]"
              v-if="cf.maintenanceBg && cf.maintenanceBg[lang]"
              :style="{'background-image': `url(${cf.maintenanceBg[lang].imageSm})`}"
              v-on:click="editText('maintenanceBg', cf.maintenanceBg,
              'Background Image', 'media/image', true, true)">
            </div>
            <div class="galleryItem invLogo add" v-else
              v-on:click="editText('maintenanceBg', cf.maintenanceBg,
              'Background Image', 'media/image', true, true)">
              Set Image</div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('maintenanceTitle',
          cf.maintenanceTitle, 'Maintenance Title', 'text', true)">
          <h4>Maintenance Title</h4>
          <p>{{cf.maintenanceTitle[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('maintenanceDesc',
          cf.maintenanceDesc, 'Maintenance Descriptions', 'textarea', true)">
          <h4>Maintenance Descriptions</h4>
          <p>{{cf.maintenanceDesc[lang]}}</p>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Social Media</h2>
        <div class="configItem configToggle">
          <h4>Display Social Media</h4>
          <div class="toggle" v-on:click="toggle('maintenanceSocmed')">
            <div class="radioItem" :class="{on: cf.maintenanceSocmed === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display social media link in Under Maintenance page?
            </div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Button</h2>
        <div class="configItem configToggle">
          <h4>Display Button</h4>
          <div class="toggle" v-on:click="toggle('maintenanceBtn')">
            <div class="radioItem" :class="{on: cf.maintenanceBtn === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display button on Under Maintenance page?
            </div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('maintenanceBtnLabel',
          cf.maintenanceBtnLabel, 'Button Label', 'text', true)">
          <h4>Button Label</h4>
          <p>{{cf.maintenanceBtnLabel[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('maintenanceBtnUrl',
          cf.maintenanceBtnUrl, 'Button Url', 'text')">
          <h4>Button Url</h4>
          <p>{{cf.maintenanceBtnUrl}}</p>
          <div class="fieldHint">User will visit this url when button clicked</div>
        </div>
      </div>
    </perfect-scrollbar>
    <perfect-scrollbar class="configContent" v-else-if="menuActive === 'dialog'">
      <div class="sectionItem">
        <h2>Basic Info</h2>
        <div class="configItem configToggle">
          <h4>Display Dialog</h4>
          <div class="toggle" v-on:click="toggle('displayDialog')">
            <div class="radioItem" :class="{on: cf.displayDialog === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display popup dialog when user visit this website?
            </div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="setColor('dialogBgColor')">
          <h4>Background Color</h4>
          <p :class="{hasColor: cf.dialogBgColor}"><span class="color"
            v-if="cf.dialogBgColor" :style="{'background-color': cf.dialogBgColor}"
            ></span>{{cf.dialogBgColor}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="setColor('dialogTextColor')">
          <h4>Text Color</h4>
          <p :class="{hasColor: cf.dialogTextColor}"><span class="color"
            v-if="cf.dialogTextColor" :style="{'background-color': cf.dialogTextColor}"
            ></span>{{cf.dialogTextColor}}</p>
        </div>
        <div class="configItem">
          <h4>Header Image</h4>
          <div class="galleryCnt">
            <div class="galleryItem invLogo" :key="`dgHdImg${i}`"
              v-for="(dgImg, i) in cf.dialogHeaderImgs">
              <div class="dgHeaderImg"
                v-if="dgImg.media && dgImg.media[lang]"
                :class="dgImg.media[lang].mimetype.split('/')[1]"
                :style="{'background-image': `url(${dgImg.media[lang].imageSm})`}"
                v-on:click="editDialogHeaderImg(i, dgImg)"></div>
              <div class="delete" v-on:click.stop="deleteDialogHeaderImg(i, dgImg)"></div>
            </div>
            <div class="galleryItem invLogo add"
              v-on:click="addDialogHeaderImg">
              Add Image</div>
          </div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('dialogTitle', cf.dialogTitle,
          'Dialog Title', 'text', true)">
          <h4>Dialog Title</h4>
          <p>{{cf.dialogTitle[lang]}}</p>
        </div>
        <div class="configItem canEdit" v-on:click="editText('dialogDesc',
          cf.dialogDesc, 'Dialog Descriptions', 'textarea', true)">
          <h4>Dialog Descriptions</h4>
          <p>{{cf.dialogDesc[lang]}}</p>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Button Links</h2>
        <div class="configItem">
          <h4>Links</h4>
          <div class="galleryCnt">
            <div class="galleryItem product noImg" v-for="(item, i) in cf.dialogLink"
              :key="`dlink${i}`" v-on:click="editDialogLink(i, item)">
              <h4>{{item.name[lang]}}</h4>
              <p v-if="item.url">{{item.url[lang]}}</p>
              <div class="delete" v-on:click.stop="deleteDialogLink(i, item)"></div>
            </div>
            <div class="galleryItem product noImg add"
              v-on:click="addDialogLink">Add Item</div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Dialog Time Delay</h2>
        <div class="configItem canEdit" v-on:click="editText('dialogExpiry',
          cf.dialogExpiry, 'Time Delay', 'number', false)">
          <h4>Time Delay</h4>
          <p><template  v-if="cf.dialogExpiry"><template
            v-if="cf.dialogExpiry >= 43800">{{(cf.dialogExpiry / 43800).toLocaleString('id',
            { maximumFractionDigits: 1 })}} bulan</template><template
            v-else-if="cf.dialogExpiry >= 10080">{{(cf.dialogExpiry / 10080).toLocaleString('id',
            { maximumFractionDigits: 1 })}} minggu</template><template
            v-else-if="cf.dialogExpiry >= 1440">{{(cf.dialogExpiry / 1440).toLocaleString('id',
            { maximumFractionDigits: 1 })}} hari</template><template
            v-else>{{cf.dialogExpiry.toLocaleString('id',{ maximumFractionDigits: 1 })}}
            menit</template></template></p>
          <div class="fieldHint">How long this dialog will re-apear after
            displayed once.</div>
        </div>
        <div class="configItem canEdit" v-on:click="editText('dialogDesc',
          cf.dialogDesc, 'Dialog Descriptions', 'textarea', true)"
          v-if="1>2">
          <h4>Display at</h4>
          <p><template  v-if="cf.dialogDisplayAt">
            <template v-if="cf.dialogDisplayAt === 'home'">Homepage</template>
            <template v-else>{{cf.dialogDisplayAt.name}}</template>
          </template><template v-else>All Page</template></p>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Social Media Links</h2>
        <div class="configItem configToggle">
          <h4>Display Social Media</h4>
          <div class="toggle" v-on:click="toggle('dialogDisplaySocmed')">
            <div class="radioItem" :class="{on: cf.dialogDisplaySocmed === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display social media link on popup dialog?
            </div>
          </div>
        </div>
      </div>
      <div class="sectionItem">
        <h2>Form</h2>
        <div class="configItem configToggle">
          <h4>Display Form</h4>
          <div class="toggle" v-on:click="toggle('dialogDisplayForm')">
            <div class="radioItem" :class="{on: cf.dialogDisplayForm === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Display form on popup dialog?
            </div>
          </div>
        </div>
        <template v-if="cf.dialogDisplayForm">
          <div class="configItem">
            <h4>Form Item</h4>
            <div class="galleryCnt">
              <div class="galleryItem product contact" v-for="(item, i) in cf.dialogFormField"
                :key="`support${i}`" v-on:click="editDialogForm(i, item)">
                <div class="thumb formField" :class="[item.type, {wa: item.isWhatsApp}]"></div>
                <h4 v-if="item.label && item.label[lang]">{{item.label[lang]}}</h4>
                <h4 v-else class="noTitle">No Label</h4>
                <p v-if="item.placeholder && item.placeholder[lang]">
                  {{item.placeholder[lang]}}</p>
                <div class="delete" v-on:click.stop="deleteDialogForm(i, item)"></div>
              </div>
              <div class="galleryItem product contact add" v-on:click="addDialogForm">
                Add Item
              </div>
            </div>
          </div>
          <div class="configItem canEdit" v-on:click="editText('dialogSubmitLabel',
            cf.dialogSubmitLabel, 'Submit Label', 'text', true)">
            <h4>Submit Label</h4>
            <p>{{cf.dialogSubmitLabel[lang]}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('dialogSuccessTitle',
            cf.dialogSuccessTitle, 'Success Title', 'text', true)">
            <h4>Success Title</h4>
            <p>{{cf.dialogSuccessTitle[lang]}}</p>
          </div>
          <div class="configItem canEdit" v-on:click="editText('dialogSuccessDesc',
            cf.dialogSuccessDesc, 'Success Subtitle', 'textarea', true)">
            <h4>Success Subtitle</h4>
            <p>{{cf.dialogSuccessDesc[lang]}}</p>
          </div>
          <div class="configItem configToggle">
            <h4>Enable Email Verification</h4>
            <div class="toggle" v-on:click="toggle('dialogEmailVerification')">
              <div class="radioItem" :class="{on: cf.dialogEmailVerification === 1}">
                <div class="radioIn">
                  <div class="radioHandle"></div>
                </div>
                Verify email for new form submission
              </div>
            </div>
          </div>
        </template>
      </div>
    </perfect-scrollbar>
    <perfect-scrollbar class="configContent" v-else-if="menuActive === 'account'">
      <div class="sectionItem">
        <h2>Account Security</h2>
        <div class="configItem configToggle">
          <h4>Enable 2FA</h4>
          <div class="toggle" v-on:click="toggle('enable2fa')">
            <div class="radioItem" :class="{on: cf.enable2fa === 1}">
              <div class="radioIn">
                <div class="radioHandle"></div>
              </div>
              Enable two factor authentication for all admin account
            </div>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <MediaInputer ref="mediaInputer"/>
    <Snackbar ref="snackbar"/>
    <AddContact ref="addContact"/>
    <Confirmation ref="confirmDialog"/>
    <AddSocmed ref="addSocmed"/>
    <LoadingDialog ref="loadingDialog"/>
    <ColorPicker ref="colorPicker"/>
    <AddForm ref="addForm"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MediaInputer from '@/components/MediaInputer.vue';
import Snackbar from '@/components/Snackbar.vue';
import AddContact from '@/components/AddContact.vue';
import Confirmation from '@/components/Confirmation.vue';
import AddSocmed from '@/components/AddSocmed.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import ColorPicker from '@/components/ColorPicker.vue';
import AddForm from '@/components/AddForm.vue';
import timezones from '../timezones';

export default {
  name: 'webConfig',
  components: {
    MediaInputer,
    Snackbar,
    AddContact,
    Confirmation,
    AddSocmed,
    LoadingDialog,
    ColorPicker,
    AddForm,
  },
  data() {
    return {
      loading: true,
      cf: null,
      menuActive: 'general',
      supports: [],
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),
    doNothing() {},
    sectionClicked() {},
    enableComment() {
      const desc = 'You need to add User Authentication extensions to enable article comment, '
        + 'so only logged in user are able to comment to prevent spam. Please contact developer '
        + 'to add User Authentication System.';
      this.$refs.confirmDialog.open({
        title: 'Missing Extensions',
        desc,
        error: true,
      });
    },
    selectMenu(menu) {
      this.menuActive = menu;
      window.history.replaceState({}, menu, `${this.$config.appPath}web/config?menu=${menu}`);
    },
    getConfig() {
      this.loading = true;
      this.$http.get(this.$config.uri('config')).then((r) => {
        this.loading = false;
        this.cf = (r.data.status === 200) ? r.data.data : null;
      });
    },
    toggle(field) {
      this.cf[field] = (this.cf[field] === 1) ? 0 : 1;
      this.saveConfig(field);
    },
    saveConfig(field, multiLang, isMedia, isArray) {
      const formData = {};
      if (multiLang && isMedia && isArray) {
        // eslint-disable-next-line
        formData[field] = this.cf[field].map((r) => {
          return {
            id: {
              mediaId: r.media && r.media.id ? r.media.id.id : null,
            },
            en: {
              mediaId: r.media && r.media.en ? r.media.en.id : null,
            },
          };
        });
      } else if (isMedia && multiLang) {
        const idId = (this.cf[field].id) ? this.cf[field].id.id : null;
        const enId = (this.cf[field].en) ? this.cf[field].en.id : null;
        formData[`${field}Id`] = { id: idId, en: enId };
      } else if (isMedia) {
        formData[`${field}Id`] = (this.cf[field]) ? this.cf[field].id : null;
      } else {
        formData[field] = JSON.parse(JSON.stringify(this.cf[field]));
      }
      let uri = 'config';
      if (multiLang && !isArray) uri += '?lang=y';
      if (isArray) {
        uri += (uri.indexOf('?') >= 0) ? '&arr=y' : '?arr=y';
        if (!multiLang) {
          // eslint-disable-next-line
          for (const item of formData[field]) {
            if (item.media) {
              item.mediaId = item.media.id;
              delete item.media;
            }
          }
        }
      }
      this.$http.post(this.$config.uri(uri), formData).then((r) => {
        this.$refs.snackbar.open({ content: 'Changes has been saved' });
      });
    },
    setColor(field) {
      this.$refs.colorPicker.open({ color: this.cf[field] }, (b, color) => {
        if (!b) return;
        this.cf[field] = color;
        this.saveConfig(field);
      });
    },
    editText(fieldName, fieldValue, title, type, multiLang, isMedia) {
      let helper = '';
      const options = [];
      if (fieldName === 'emailProvider') {
        options.push('Mailgun');
        options.push('SMTP');
      } else if (fieldName === 'timezone') {
        options.push(...timezones);
      }
      if (fieldName === 'dateFormat') {
        helper = 'Default to DD MMM YYYY, for more infor please visit '
          + '<a href="https://momentjs.com/docs/#/displaying/format/" target="_blank">'
          + 'Date format info</a>';
      } else if (fieldName === 'timeFormat') {
        helper = 'Default to HH:mm, HH for 24 hour, hh for 12 hours. '
          + 'For more infor please visit '
          + '<a href="https://momentjs.com/docs/#/displaying/format/" target="_blank">'
          + 'Date format info</a>';
      } else if (fieldName === 'dialogExpiry') {
        helper = 'Please input expiry in minutes';
      }
      this.$refs.mediaInputer.open({
        title,
        options,
        type,
        placeholder: `${title}...`,
        model: fieldValue,
        action: 'Save Changes',
        helper,
        multiLang,
      }, (b, v) => {
        if (!b) return;
        this.cf[fieldName] = v; // eslint-disable-line
        this.saveConfig(fieldName, multiLang, isMedia);
      });
    },
    deleteItem(field, name, i, item) {
      this.$refs.confirmDialog.open({
        title: `Delete ${name} Item`,
        desc: `Are you sure you want to delete ${item.value} from ${name}'s list?`,
      }, (b) => {
        if (!b) return;
        this.cf[field].splice(i, 1);
        this.saveConfig(field, false, false, true);
      });
    },
    editItem(field, name, i, item) {
      this.$refs.mediaInputer.open({
        title: name,
        type: 'text',
        model: item.value,
        placeholder: name,
        action: 'Save Changes',
      }, (b, v) => {
        if (!b) return;
        this.cf[field][i].value = v;
        this.saveConfig(field, false, false, true);
      });
    },
    addItem(field, name) {
      this.$refs.mediaInputer.open({
        title: name,
        type: 'text',
        placeholder: name,
        action: 'Save Changes',
      }, (b, v) => {
        if (!b) return;
        this.cf[field].push({ value: v });
        this.saveConfig(field, false, false, true);
      });
    },

    /**
     * Footer pages
     *
     */
    deletePage(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Link Group',
        desc: 'Are you sure you want to delete this link item?',
      }, (b) => {
        if (!b) return;
        this.cf.page.splice(i, 1);
        this.saveConfig('page', false, false, true);
      });
    },
    addPage() {
      this.cf.page.push({
        title: { id: '', en: '' },
        links: [],
      });
      this.saveConfig('page', false, false, true);
    },
    deletePageItem(item, i, link) {
      this.$refs.confirmDialog.open({
        title: 'Delete Link Item',
        desc: 'Are you sure you want to delete this link item?',
      }, (b) => {
        if (!b) return;
        item.links.splice(i, 1);
        this.saveConfig('page', false, false, true);
      });
    },
    editPageItem(item, i, link) {
      this.$refs.confirmDialog.open({
        title: 'Edit Link Item',
        desc: 'Fill link information below',
        action: 'Save Link',
        multiLang: true,
        inputs: [
          {
            label: 'Link Name',
            placeholder: 'Link name...',
            value: { id: link.name.id, en: link.name.en },
            type: 'text',
          },
          {
            label: 'Link Url',
            placeholder: 'https://...',
            value: { id: link.url.id, en: link.url.en },
            type: 'text',
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        item.links[i].name.id = v[0].value.id; // eslint-disable-line
        item.links[i].name.en = v[0].value.en; // eslint-disable-line
        item.links[i].url.id = v[1].value.id; // eslint-disable-line
        item.links[i].url.en = v[1].value.en; // eslint-disable-line
        this.saveConfig('page', false, false, true);
      });
    },
    addPageItem(item) {
      this.$refs.confirmDialog.open({
        title: 'Add Link Item',
        desc: 'Fill link information below',
        action: 'Save Link',
        multiLang: true,
        inputs: [
          {
            label: 'Link Name',
            placeholder: 'Link name...',
            value: { id: '', en: '' },
            type: 'text',
          },
          {
            label: 'Link Url',
            placeholder: 'https://...',
            value: { id: '', en: '' },
            type: 'text',
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        item.links.push({ name: v[0].value, url: v[1].value });
        this.saveConfig('page', false, false, true);
      });
    },
    editTextPage(item, field, value, title, type, multiLang) {
      this.$refs.mediaInputer.open({
        title,
        type,
        placeholder: title,
        model: value,
        action: 'Save Changes',
        multiLang,
      }, (b, v) => {
        if (!b) return;
        item[field] = v; // eslint-disable-line
        this.saveConfig('page', false, false, true);
      });
    },

    deleteSupport(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Contact Support',
        desc: 'Are you sure you want to delete this contact support item?',
      }, (b) => {
        if (!b) return;
        this.cf.support.splice(i, 1);
        this.saveConfig('support', false, false, true);
      });
    },
    editSupport(i, item) {
      this.$refs.addContact.open(item, (b, v) => {
        if (!b) return;
        this.cf.support[i] = v;
        const supportTmp = JSON.parse(JSON.stringify(this.cf.support));
        this.cf.support = [];
        setTimeout(() => {
          this.cf.support = supportTmp;
          this.saveConfig('support', false, false, true);
        });
      });
    },
    addSupport() {
      this.$refs.addContact.open(null, (b, v) => {
        if (!b) return;
        this.cf.support.push(v);
        this.saveConfig('support', false, false, true);
      });
    },
    editSocmed(i, item) {
      this.$refs.addSocmed.open(item, (b, m) => {
        if (!b) return;
        this.cf.socmed[i] = m;
        const socmedsTmp = JSON.parse(JSON.stringify(this.cf.socmed));
        this.cf.socmed = [];
        setTimeout(() => {
          this.cf.socmed = socmedsTmp;
          this.saveConfig('socmed', false, false, true);
        });
      });
    },
    deleteSocmed(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Social Media Item',
        desc: `Are you sure you want to delete ${item.name} from social media item?`,
      }, (b) => {
        if (!b) return;
        this.cf.socmed.splice(i, 1);
        this.saveConfig('socmed', false, false, true);
      });
    },
    addSocmed() {
      this.$refs.addSocmed.open(null, (b, o) => {
        if (!b) return;
        this.cf.socmed.push(o);
        this.saveConfig('socmed', false, false, true);
      });
    },

    /**
     * Footer Logos
     *
     */
    editFooterLogo(i, item) {
      this.$refs.addSocmed.open(item, (b, m) => {
        if (!b) return;
        this.cf.footerLogos[i] = m;
        const footerLogosTmp = JSON.parse(JSON.stringify(this.cf.footerLogos));
        this.cf.footerLogos = [];
        setTimeout(() => {
          this.cf.footerLogos = footerLogosTmp;
          this.saveConfig('footerLogos', false, false, true);
        });
      });
    },
    deleteFooterLogo(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Footer Logo Item',
        desc: `Are you sure you want to delete ${item.name} from footer logo item?`,
      }, (b) => {
        if (!b) return;
        this.cf.footerLogos.splice(i, 1);
        this.saveConfig('footerLogos', false, false, true);
      });
    },
    addFooterLogo() {
      this.$refs.addSocmed.open(null, (b, o) => {
        if (!b) return;
        this.cf.footerLogos.push(o);
        this.saveConfig('footerLogos', false, false, true);
      });
    },

    /**
     * Subscription
     *
     */
    addSubscriptionForm() {
      this.$refs.addForm.open(null, (b, v) => {
        if (!b) return;
        this.cf.subFormField.push(v);
        this.saveConfig('subFormField', false, false, true);
      });
    },
    deleteSubscriptionForm(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Form Field',
        desc: 'Are you sure you want to delete this form filed from subscription form?',
      }, (b) => {
        if (!b) return;
        this.cf.subFormField.splice(i, 1);
        this.saveConfig('subFormField', false, false, true);
      });
    },
    editSubscriptionForm(i, item) {
      this.$refs.addForm.open(item, (b, v) => {
        if (!b) return;
        this.cf.subFormField[i] = v;
        const subFormFieldTmp = JSON.parse(JSON.stringify(this.cf.subFormField));
        this.cf.subFormField = [];
        setTimeout(() => {
          this.cf.subFormField = subFormFieldTmp;
          this.saveConfig('subFormField', false, false, true);
        });
      });
    },

    /**
     * Dialog
     *
     */
    addDialogHeaderImg() {
      this.$refs.confirmDialog.open({
        title: 'Add Header Image',
        desc: 'Please select media by clicking Select Media button below',
        multiLang: true,
        action: 'Set Image',
        inputs: [
          {
            label: 'Header Image',
            placeholder: 'Select media...',
            value: { id: null, en: null },
            type: 'media',
            mediaTypes: ['image'],
            error: null,
          },
        ],
      }, (b, c, d, m) => {
        if (!b) return;
        this.cf.dialogHeaderImgs.push({ media: m[0].value });
        this.saveConfig('dialogHeaderImgs', true, true, true);
      });
    },
    editDialogHeaderImg(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Add Header Image',
        desc: 'Please select media by clicking Select Media button below',
        multiLang: true,
        action: 'Set Image',
        inputs: [
          {
            label: 'Header Image',
            placeholder: 'Select media...',
            value: item.media,
            type: 'media',
            mediaTypes: ['image'],
            error: null,
          },
        ],
      }, (b, c, d, m) => {
        if (!b) return;
        this.cf.dialogHeaderImgs[i].media = m[0].value;
        this.saveConfig('dialogHeaderImgs', true, true, true);
      });
    },
    deleteDialogHeaderImg(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Dialog Header Image',
        desc: `Are you sure you want to delete ${item.name} from dialog header image item?`,
      }, (b) => {
        if (!b) return;
        this.cf.dialogHeaderImgs.splice(i, 1);
        this.saveConfig('dialogHeaderImgs', true, true, true);
      });
    },
    addDialogLink() {
      this.$refs.confirmDialog.open({
        title: 'Add Link Item',
        desc: 'Fill link information below',
        action: 'Save Link',
        multiLang: true,
        inputs: [
          {
            label: 'Link Name',
            placeholder: 'Link name...',
            value: { id: '', en: '' },
            type: 'text',
          },
          {
            label: 'Link Url',
            placeholder: 'https://...',
            value: { id: '', en: '' },
            type: 'text',
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        this.cf.dialogLink.push({ name: v[0].value, url: v[1].value });
        this.saveConfig('dialogLink', false, false, true);
      });
    },
    deleteDialogLink(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Link Item',
        desc: 'Are you sure you want to delete this link from dialog links?',
      }, (b) => {
        if (!b) return;
        this.cf.saveConfig.splice(i, 1);
        this.saveConfig('dialogLink', false, false, true);
      });
    },
    editDialogLink(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Add Link Item',
        desc: 'Fill link information below',
        action: 'Save Link',
        multiLang: true,
        inputs: [
          {
            label: 'Link Name',
            placeholder: 'Link name...',
            value: { id: item.name.id, en: item.name.en },
            type: 'text',
          },
          {
            label: 'Link Url',
            placeholder: 'https://...',
            value: { id: item.url.id, en: item.url.en },
            type: 'text',
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        this.cf.dialogLink[i].name = v[0].value;
        this.cf.dialogLink[i].url = v[1].value;
        this.saveConfig('dialogLink', false, false, true);
      });
    },
    addDialogForm() {
      this.$refs.addForm.open(null, (b, v) => {
        if (!b) return;
        this.cf.dialogFormField.push(v);
        this.saveConfig('dialogFormField', false, false, true);
      });
    },
    deleteDialogForm(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Form Field',
        desc: 'Are you sure you want to delete this form filed from dialog form?',
      }, (b) => {
        if (!b) return;
        this.cf.dialogFormField.splice(i, 1);
        this.saveConfig('dialogFormField', false, false, true);
      });
    },
    editDialogForm(i, item) {
      this.$refs.addForm.open(item, (b, v) => {
        if (!b) return;
        this.cf.dialogFormField[i] = v;
        const dialogFormFieldTmp = JSON.parse(JSON.stringify(this.cf.dialogFormField));
        this.cf.dialogFormField = [];
        setTimeout(() => {
          this.cf.dialogFormField = dialogFormFieldTmp;
          this.saveConfig('dialogFormField', false, false, true);
        });
      });
    },
  },
  beforeDestroy() {},
  mounted() {
    this.chCGB(false);
    this.chTitle('Settings');
    this.chDirId(0);
    this.menuActive = (this.$route.query && this.$route.query.menu)
      ? this.$route.query.menu : 'general';
    this.getConfig();
  },
};
</script>

<style scoped lang="scss">
.content.loading{
  background-image: url(../assets/loading-2.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}
.content.ok{
  display: flex;
  padding: 0 !important;
  position: relative;
  .configMenu{
    height: calc(100vh - 49px);
    width: 300px;
    border-right: #eee 1px solid;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 10px 0 40px;
    .addNewPage{
      margin: 10px 20px;
      display: block;
    }
    li{
      list-style: none;
      padding: 10px 20px;
      // font-size: 17px;
      // font-weight: 600;
      margin: 0 10px 4px;
      border-radius: 5px;
      cursor: pointer;
      transition: all .3s ease;
      box-sizing: border-box;
      position: relative;
      padding-right: 86px;
      &:hover{
        background-color: #f5f5fe;
      }
      &.loading{
        background-color: #eee;
        height: 32px;
        border-radius: 50px;
        margin: 0 20px;
        cursor: default;
      }
      &.mainPage{
        position: relative;
        &:before{
          content: "";
          position: absolute;
          left: 2px; top: 12px;
          width: 14px; height: 14px;
          background-image: url(../assets/crown-orange.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      p{
        font-size: 13px;
        color: #767676;
        margin: 0;
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .actionCnt{
        display: flex;
        align-items: center;
        position: absolute;
        right: 6px; top: 6px;
        .actionItem{
          margin-left: 3px;
          width: 30px; height: 30px;
          border-radius: 50%;
          background-size: 14px auto;
          background-position: center;
          background-repeat: no-repeat;
          cursor: pointer;
          position: relative;
          transition: box-shadow .3s ease, background-color .3s ease;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
            background-color: #fff;
          }
          &.more{
            background-image: url(../assets/more.png);
            opacity: .65;
            &.open{
              opacity: 1;
            }
          }
          .actionMenu{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            padding: 8px 0;
            border-radius: 5px;
            box-shadow: 0 0 4px rgba(0, 0, 0, .2);
            right: 100%; top: 0;
            .divider{
              height: 1px;
              background-color: #eee;
              margin: 5px 0;
            }
            li{
              margin: 0;
              border-radius: 0;
              list-style: none;
              font-size: 15px;
              white-space: nowrap;
              padding: 8px 24px;
              padding-left: 16px;
              cursor: pointer;
              transition: all .3s ease;
              display: flex;
              align-items: center;
              &.red{
                color: red;
              }
              .icon{
                width: 18px; height: 18px;
                margin-right: 10px;
                background-size: 16px auto;
                background-position: center;
                background-repeat: no-repeat;
                &.link{
                  background-image: url(../assets/external-link-black.png);
                  background-size: 16px auto;
                  opacity: .65;
                }
                &.delete{
                  background-image: url(../assets/delete.png);
                }
                &.lock{
                  background-image: url(../assets/private-o.png);
                  background-size: 18px auto;
                }
                &.edit{
                  background-image: url(../assets/edit-black.png);
                  background-size: 15px auto;
                  opacity: .76;
                }
                &.main{
                  background-image: url(../assets/crown-black.png);
                  background-size: 15px auto;
                  opacity: .64;
                }
              }
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .draft{
          color: red;
          font-size: 14px;
          border-radius: 3px;
          background-color: #fff4f4;
          padding: 1px 5px 2px;
        }
      }
      &.active{
        background-color: #bdd8ff;
        color: #222;
        p{
          color: #444;
        }
      }
    }
  }
  .ccTitle{
    position: absolute;
    right: 0; top: 0; left: 300px;
    border-bottom: #eee 1px solid;
    font-size: 17px;
    font-weight: 600;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 30px;
    height: 44px;
    margin: 0;
  }
  .endSection{
    border-top: #eee 1px solid;
    margin-top: 20px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    position: absolute;
    left: 300px; bottom: 0; right: 0;
    height: 60px;
    background-color: #fff;
    .actionCnt{
      margin-left: auto;
      display: flex;
      align-items: center;
      .actionItem{
        width: 36px; height: 36px;
        border-radius: 50%;
        margin-left: 4px;
        transition: background-color .3s ease, opacity .3s ease;
        cursor: pointer;
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .46;
        position: relative;
        &.open{
          opacity: 1;
          .info{
            display: none !important;
          }
        }
        &.history{
          background-image: url(../assets/history.png);
        }
        &.draft{
          background-image: url(../assets/completed.png);
          background-size: 18px;
        }
        &.loading{
          background-image: url(../assets/loading-2.svg);
          background-size: 25px auto;
          opacity: .76;
        }
        .info{
          position: absolute;
          font-size: 12px;
          background-color: #222;
          padding: 4px 6px;
          display: none;
          bottom: 100%; left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
          color: #fff;
          border-radius: 3px;
          &:before{
            content: "";
            position: absolute;
            left: 50%; top: 100%;
            border-top: #222 4px solid;
            border-left: transparent 4px solid;
            border-right: transparent 4px solid;
            margin-left: -2px;
          }
        }
        .actionMenu{
          background-color: #fff;
          position: absolute;
          bottom: 100%;
          padding: 8px 0;
          border-radius: 5px;
          left: 50%;
          transform: translateX(-50%);
          box-shadow: 0 0 4px rgba(0, 0, 0, .2);
          margin-bottom: 4px;
          cursor: default;
          &:before{
            content: "";
            position: absolute;
            left: 50%; top: 100%;
            border-top: #eee 6px solid;
            border-left: transparent 6px solid;
            border-right: transparent 6px solid;
            margin-left: -4px;
          }
          &:after{
            content: "";
            position: absolute;
            left: 50%; top: 100%;
            border-top: #fff 4px solid;
            border-left: transparent 4px solid;
            border-right: transparent 4px solid;
            margin-left: -2px;
            z-index: 3;
          }
          h4{
            white-space: nowrap;
            padding: 10px 20px;
            margin: 0;
            font-weight: 600;
            font-size: 16px;
          }
          .historyCnt{
            width: 340px;
            min-height: 240px;
            max-height: 340px;
            overflow: auto;
            border-top: #eee 1px solid;
            border-bottom: #eee 1px solid;
            padding: 6px 0;
            box-sizing: border-box;
            &.noData{
              padding: 16px 20px;
              color: #767676;
              font-size: 14px;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              .noDataIn{
                width: 100%;
              }
              img{
                display: block;
                width: 46px;
                margin: 0 auto 10px;
                opacity: .46;
              }
            }
            .historyItem{
              padding: 8px 20px;
              transition: all .3s ease;
              cursor: pointer;
              &:hover{
                background-color: #f5f5fe;
              }
              h5{
                margin: 0;
                font-size: 15px;
                font-weight: 600;
              }
              p{
                margin: 0;
                color: #767676;
                font-weight: normal;
                font-size: 14px;
                b{
                  font-weight: 600;
                  color: #444;
                }
              }
            }
            &.loading{
              background-image: url(../assets/loading-2.svg);
              background-size: 26px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          .divider{
            height: 1px;
            background-color: #eee;
            margin: 5px 0;
          }
          li{
            list-style: none;
            font-size: 15px;
            white-space: nowrap;
            padding: 6px 24px;
            padding-left: 16px;
            cursor: pointer;
            transition: all .3s ease;
            display: flex;
            align-items: center;
            &.red{
              color: red;
            }
            .icon{
              width: 18px; height: 18px;
              margin-right: 10px;
              background-size: 18px auto;
              background-position: center;
              background-repeat: no-repeat;
              &.delete{
                background-image: url(../assets/delete.png);
              }
              &.save{
                background-image: url(../assets/save.png);
                background-size: 16px auto;
              }
            }
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
        &:hover{
          background-color: #eee;
          opacity: 1;
          .info{
            display: block;
          }
        }
      }
      .btn{
        margin-left: 6px;
        &.btnSecondary{
          font-weight: 600;
          font-size: 16px;
        }
      }
    }
  }
  .configContent{
    width: calc(100% - 300px);
    height: calc(100vh - 93px);
    box-sizing: border-box;
    overflow-y: auto;
    padding: 0 0 40px;
    margin-top: 44px;
    &.loading{
      background-image: url(../assets/loading-2.svg);
      background-size: 46px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    .ccTitle{
      border-bottom: #eee 1px solid;
      font-size: 20px;
      margin: 0;
      font-weight: 600;
      padding: 10px 30px;
    }
    h2{
      margin: 0;
      padding: 10px 40px;
      font-size: 22px;
      font-weight: 600;
    }
    .sectionItem{
      margin-top: 20px;
      padding: 0 0 16px;
      .deleteLink{
        color: red;
        position: relative;
        padding: 5px 12px;
        padding-left: 32px;
        margin-left: 40px;
        font-size: 14px;
        margin-bottom: 20px;
        cursor: pointer;
        border-radius: 50px;
        display: inline-block;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: #eee;
        }
        &:before{
          content: "";
          position: absolute;
          left: 10px; top: 0; bottom: 0;
          width: 15px;
          background-image: url(../assets/delete.png);
          background-size: 15px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .addSection{
        margin: 6px 40px 0;
      }
      .sectionTitle{
        position: relative;
        border-bottom: #eee 1px solid;
        cursor: pointer;
        &:hover{
          // background-color: #f5f5f5;
        }
        .sectionOption{
          width: 34px; height: 34px;
          position: absolute;
          right: 30px; top: 8px;
          border-radius: 50%;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .56;
          background-image: url(../assets/more.png);
          cursor: pointer;
          transition: background-color .3s ease;
          &.open{
            opacity: 1;
          }
          &:hover{
            background-color: #eee;
          }
          .sectionOptions{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            padding: 8px 0;
            border-radius: 5px;
            box-shadow: 0 0 4px rgba(0, 0, 0, .2);
            right: 100%; top: 0;
            .divider{
              height: 1px;
              background-color: #eee;
              margin: 5px 0;
            }
            li{
              margin: 0;
              border-radius: 0;
              list-style: none;
              font-size: 15px;
              white-space: nowrap;
              padding: 8px 24px;
              padding-left: 16px;
              cursor: pointer;
              transition: all .3s ease;
              display: flex;
              align-items: center;
              &.red{
                color: red;
              }
              .icon{
                width: 18px; height: 18px;
                margin-right: 10px;
                background-size: 16px auto;
                background-position: center;
                background-repeat: no-repeat;
                &.link{
                  background-image: url(../assets/external-link-black.png);
                  background-size: 16px auto;
                  opacity: .65;
                }
                &.delete{
                  background-image: url(../assets/delete.png);
                }
                &.lock{
                  background-image: url(../assets/private-o.png);
                  background-size: 18px auto;
                }
                &.edit{
                  background-image: url(../assets/edit-black.png);
                  background-size: 15px auto;
                  opacity: .76;
                }
                &.main{
                  background-image: url(../assets/crown-black.png);
                  background-size: 15px auto;
                  opacity: .64;
                }
              }
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .sectionDh{
          width: 34px; height: 34px;
          position: absolute;
          left: 6px; top: 8px;
          border-radius: 50%;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .65;
          background-image: url(../assets/drag-and-drop.png);
          cursor: pointer;
          transition: all .3s ease;
        }
        .sectionDd{
          width: 34px; height: 34px;
          position: absolute;
          right: 68px; top: 8px;
          border-radius: 50%;
          background-size: 12px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .45;
          background-image: url(../assets/down-arrow.png);
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .sectionItemWrapper{
        transition: all .3s ease;
      }
    }
    .configItem{
      padding: 12px 40px;
      position: relative;
      &.configToggle{
        padding-bottom: 20px;
      }
      .fieldHint{
        margin-left: 0;
      }
      &.canEdit{
        cursor: pointer;
        transition: background-color .3s ease;
        &:before{
          content: "";
          position: absolute;
          left: 12px; top: 28px;
          width: 20px; height: 20px;
          background-image: url(../assets/edit-black.png);
          background-size: 12px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .56;
        }
        &:hover{
          background-color: #f5f5fe;
        }
      }
      .toggle{
        padding-top: 6px;
        .radioItem{
          padding-left: 60px;
        }
      }
      h4{
        margin: 0;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 13px;
        color: #888;
      }
      p{
        margin: 0;
        white-space: pre-wrap;
        line-height: 1.3;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
                line-clamp: 3;
        -webkit-box-orient: vertical;
        &.hasColor{
          position: relative;
          padding-left: 26px;
          margin-top: 4px;
          span.color{
            position: absolute;
            width: 20px; height: 20px;
            border-radius: 3px;
            left: 0; top: 0;
            box-sizing: border-box;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
        }
        &:empty::before {
          content: 'Not set';
          color: #999;
          font-style: italic;
        }
      }
      .features{
        display: flex;
        padding: 6px 0 0;
        .featureItem{
          border-radius: 5px;
          border: #eee 1px solid;
          margin: 0 10px 0 0;
          padding: 10px 14px;
          box-sizing: border-box;
          width: 200px;
          h4{
            font-size: 17px;
            font-weight: normal;
            text-transform: none;
            color: #444;
            margin: 0 0 4px;
          }
          p{
            font-size: 14px;
            color: #767676;
          }
        }
      }
      .numberCnt{
        display: flex;
        flex-wrap: wrap;
        padding: 6px 0 0;
        margin-bottom: -10px;
        .numberItem{
          border-radius: 5px;
          border: #eee 1px solid;
          margin: 0 10px 10px 0;
          padding: 10px 14px 16px;
          // text-align: center;
          box-sizing: border-box;
          position: relative;
          cursor: pointer;
          min-height: 40px;
          h4{
            font-size: 24px;
            font-weight: 600;
            color: #444;
            text-transform: none;
            white-space: nowrap;
            margin: 0;
          }
          p{
            font-size: 13px;
            white-space: nowrap;
            margin: 0;
            color: #767676;
          }
          .delete{
            content: "";
            position: absolute;
            right: -8px; top: -8px;
            width: 20px; height: 20px;
            background-image: url(../assets/close-white.png);
            background-color: red;
            border-radius: 50%;
            background-size: 8px auto;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
            transition: all .3s ease;
            opacity: .8;
            &:hover{
              opacity: 1;
              box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
            }
          }
          &:hover{
            background-color: #f5f5fe;
          }
          &.add{
            background-color: #eee;
            color: #999;
            font-weight: 600;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all .3s ease;
            line-height: 0;
            padding: 0 20px;
            .delete{
              display: none;
            }
            &:hover{
              background-color: #ddd;
              color: #767676;
            }
          }
          &.support{
            text-align: left;
            height: 68px;
            &.phone{
              height: auto;
              padding: 12px 16px;
            }
            h4{
              font-size: 17px;
            }
            p{
              font-size: 15px;
            }
          }
        }
      }
      .galleryCnt{
        display: flex;
        padding: 6px 0 0;
        flex-wrap: wrap;
        margin-bottom: -10px;
        &.dataAuto{
          color: #767676;
          font-style: italic;
        }
        .galleryItem{
          margin: 0 10px 10px 0;
          width: 120px; height: 80px;
          background-color: #eee;
          border-radius: 5px;
          position: relative;
          background-size: cover;
          background-position: center;
          transition: all .3s ease;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
          .galleryImg{
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            border-radius: 5px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            transition: opacity .3s ease;
            cursor: pointer;
            &.noImg{
              background-size: 36px auto;
              background-image: url(../assets/photo-black.png);
              opacity: .36;
              &:hover{
                opacity: .46;
              }
            }
          }
          .delete{
            content: "";
            position: absolute;
            right: -8px; top: -8px;
            width: 20px; height: 20px;
            background-image: url(../assets/close-white.png);
            background-color: red;
            border-radius: 50%;
            background-size: 8px auto;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
            transition: all .3s ease;
            opacity: .8;
            &:hover{
              opacity: 1;
              box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
            }
          }
          &.add{
            background-color: #eee;
            color: #999;
            font-weight: 600;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all .3s ease;
            line-height: 0;
            padding: 0 20px;
            &:hover{
              background-color: #ddd;
              color: #767676;
            }
          }
          &.banner{
            height: 60px;
            cursor: pointer;
          }
          &.invLogo{
            height: 120px;
            cursor: pointer;
            background-size: cover;
            background-repeat: no-repeat;
            position: relative;
            &.png, &.gif, &.svg{
              background-size: contain;
            }
            &.add{
              padding: 0;
            }
            .dgHeaderImg{
              position: absolute;
              left: 0; top: 0; right: 0; bottom: 0;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 5px;
            }
          }
          &.product{
            width: auto;
            height: auto;
            min-height: 54px;
            background-color: #fff;
            border: #eee 1px solid;
            padding: 6px 20px;
            padding-left: 60px;
            box-sizing: border-box;
            cursor: pointer;
            max-width: 260px;
            &.noImg{
              padding-left: 20px;
            }
            h4{
              text-transform: none;
              font-size: 16px;
              font-weight: 600;
              color: #444;
              margin: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &.noTitle{
                color: #999;
                font-style: italic;
                padding-right: 6px;
              }
            }
            p{
              margin: -1px 0 0;
              font-size: 14px;
              color: #767676;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &.add{
              background-color: #eee;
              padding: 0 20px;
            }
            .thumb{
              left: 8px;
              top: 6px;
              position: absolute;
              width: 40px;
              height: 40px;
              background-color: #e5e5e5;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 4px;
              opacity: 1;
              display: inline-block;
              &.png, &.gif, &.svg{
                background-size: contain;
              }
              &.Email,
              &.Phone,
              &.Help.Page{
                background-color: transparent;
                background-size: 22px auto;
                background-position: center;
                opacity: .56;
              }
              &.Email{
                background-image: url(../assets/email.png);
              }
              &.Phone{
                background-image: url(../assets/phone2.png);
                &.wa{
                  background-image: url(../assets/whatsapp-green.png);
                  opacity: 1;
                }
              }
              &.Help.Page{
                background-image: url(../assets/help-page.png);
              }
              &.formField{
                background-color: transparent;
                background-size: 22px auto;
                background-position: center;
                opacity: .56;
                &.text{
                  background-image: url(../assets/short-text.png);
                }
                &.textarea{
                  background-image: url(../assets/long-text.png);
                }
                &.select{
                  background-image: url(../assets/dropdown.png);
                }
                &.checkbox{
                  background-image: url(../assets/checkbox.png);
                }
                &.date{
                  background-image: url(../assets/calendar.png);
                }
              }
              &.noImg{
                background-color: #ccc;
                opacity: .36;
                background-image: url(../assets/image-black.png);
                background-size: 20px auto;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
          }
        }
      }
    }
  }
}
</style>
